import '@babel/polyfill'
import 'ie-array-find-polyfill'
import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import AdminPage from './containers/AdminPage'
import HomePage from './containers/HomePage'
import EventPage from './containers/EventPage'
import CheckInPage from './containers/CheckInPage'

class App extends Component {
    render() {
        return (
            <Switch>
                <Route path="/admin" component={AdminPage} />
                <Route path="/checkin/:confirmation" component={CheckInPage} />
                <Route path="/:event" component={EventPage} />
                <Route path="/" component={HomePage} />
            </Switch>
        )
    }
}

export default App
